import { render } from "./AccessDenied.vue?vue&type=template&id=4dd58a72&ts=true&lang=pug"
import script from "./AccessDenied.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessDenied.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__